window.menuCatalogSections = function () {
  let $menuCatalogSections = $(document).find(".x-menu-sections")
  if ($menuCatalogSections.length) {
    let $boxLinks = $menuCatalogSections.find(".x-menu-sections-link")
    if ($boxLinks.length) {
      $.each($boxLinks.find(".x-menu-sections-item"), function (index, element) {
        $menuCatalogSections.append(element)
      })
      $boxLinks.remove()
    }
    let wid = $menuCatalogSections.outerWidth(),
      $menuItems = $menuCatalogSections.find(".x-menu-sections-item"),
      widItems = 0,
      widLastItem = 0,
      indexRemove = 0,
      paddingItem = 0,
      widthSpan = 0,
      widthSpanLast = 0
    $.each($menuItems, function (index, element) {
      $(element).find(".porridge__link").css("padding-left", "").css("padding-right", "")
    })

    $.each($menuItems, function (index, element) {
      if (widItems + $(element).outerWidth() <= wid) {
        widLastItem = $(element).outerWidth()
        widItems = widItems + widLastItem
        indexRemove = index
        widthSpanLast = $(element).find(".porridge__text").outerWidth()
        widthSpan = widthSpan + widthSpanLast
      }
    })
    widthSpan = widthSpan - widthSpanLast
    let differenceWidth = wid - widthSpan - 60 - indexRemove - 7
    if (indexRemove + 1 < $menuItems.length) {
      let $linkBox = $("<div/>", {
        class: "menu__sections-link x-menu-sections-link",
        mouseover: function () {
          $(this).addClass("menu__sections-link-show")
        },
        mouseout: function () {
          $(this).removeClass("menu__sections-link-show")
        },
      })
      let $links = $("<div/>", {
        class: "menu__sections-links x-menu-sections-links",
      })
      $.each($menuItems, function (index, element) {
        if (index >= indexRemove) {
          $links.append($(element))
        }
      })
      $linkBox.append($links)

      $menuCatalogSections.append($linkBox)
      if (differenceWidth > 0) {
        paddingItem = differenceWidth / (indexRemove * 2)
        /*if (paddingItem > 17.1) {
          paddingItem = 17.1;
        }*/
        $.each($menuItems, function (index, element) {
          if (!$(element).parents(".x-menu-sections-link").length) {
            $(element)
              .find(".porridge__link")
              .css("padding-left", paddingItem + "px")
              .css("padding-right", paddingItem + "px")
          }
        })
      }
    }
  }
}
window.menuCatalogSections()
;(function ($) {
  "use strict"
  $(function () {
    $(window).resize(function () {
      window.menuCatalogSections()
    })
  })
})(jQuery)
